<template>
    <div>
        <Button @click="onRoomClick">物品清单</Button>
        <span style="margin-left: 10px">已添加 x{{ count }}</span>
        <smart-modal
            v-model="showRoomConfig"
            :title="'物品清单'"
            :height="400"
            :width="860"
            :async="false"
            :buttons="buttons"
            :modalBeforeBtnClick="{
                confirm: onConfirm,
            }"
        >
            <Form ref="info" :model="info" :viewonly="justRead">
                <Row :gutter="20">
                    <Col span="4" style="text-align: right; line-height: 30px"
                        >物品名称</Col
                    >
                    <Col span="20">
                        <FormItem>
                            <room-config
                                ref="roomConfig"
                                :value="value"
                            />
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="20">
                    <Col span="4" style="text-align: right">备注</Col>
                    <Col span="20">
                        <FormItem prop="remark">
                            <Input
                                v-model="info.remark"
                                type="textarea"
                                :rows="3"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </smart-modal>
    </div>
</template>
<script>
import { Field } from 'ivux'
import RoomConfig from './room-config'

// 物品清单
export default {
    name: 'FacilityList',

    mixins: [Field],

    components: {
        RoomConfig,
    },

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        remark: {
            type: String,
            default: '',
        },
        populateType: {
            default: 'through',
        },
        // 只读，不可编辑
        justRead: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showRoomConfig: false,
            count: 0,
            info: {
                remark: '',
            },
        }
    },
    computed: {
        buttons() {
            const btns = [{ type: 'default', text: '取消', name: 'cancel' }]
            if (!this.justRead) {
                btns.unshift({
                    type: 'primary',
                    text: '确定',
                    name: 'confirm',
                })
            }

            return btns
        },
    },
    watch: {
        value: {
            handler(val) {
                this.count = val.length
            },
            immediate: true,
        },
        'info.remark'(val) {
            this.$emit('remark-change', val)
        },
    },
    created() {
        this.info.remark = this.remark
        this.count = this.value.length
    },
    methods: {
        onRoomClick() {
            this.showRoomConfig = true
        },

        onConfirm(next, options) {
            this.$refs.roomConfig
                .validate()
                .then(() => {
                    var list = this.$refs.roomConfig.populateData()

                    this.count = list.length
                    this.$emit('input', list)
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => next())
        },
    },
}
</script>
<style lang="less" scoped></style>
